<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <ServiceValueForm @submit-requested="submitRequested"></ServiceValueForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import ServiceValueForm from './ServiceValueForm.vue'

  export default {
  components: { ServiceValueForm },
  methods: {
    ...mapActions('serviceValue', ['postServiceValue']),
    submitRequested (input) {
      this.postServiceValue(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 